import React, { Component } from "react";
import BlobUtil from '../../utils/blobUtil'

interface PropsFromState {

}

interface PropsFromDispatch {
  sourceVideo: any
  videoThumbnail: string
  hidden: boolean
}
type AllProps = PropsFromState & PropsFromDispatch

interface IState {

}
export default class VideoPlayer extends Component<AllProps, IState> {
  videoRef?: HTMLVideoElement | undefined | null;
  myPlayer?: amp.Player;
  seeking: boolean = false;
  blobUtil: BlobUtil;

  constructor(props: AllProps) {
    super(props);
    this.blobUtil = new BlobUtil();
  }

  async getVideoUrl(fileName:string) {
      let blobRequestUrl = await this.blobUtil.GetBlob2("courses", fileName);
      return blobRequestUrl;
  }

  async initPlayer() {

    let videoSrc = this.props.sourceVideo;
    videoSrc.src = await this.getVideoUrl(videoSrc.src);

    this.myPlayer = amp(
      this.videoRef,
      {
        logo: { enabled: false },
        autoplay: false,
        fluid: true
      },
      () => {
        console.log("Good to go!");
      }
    );

    //this.myPlayer.src([this.props.sourceVideo]);
    this.myPlayer.src([videoSrc]);
    this.myPlayer.poster(this.props.videoThumbnail);
    this.myPlayer.addEventListener(amp.eventName.timeupdate, () => {
      if (this.myPlayer === undefined)
        return;

      if (this.seeking === true)
        return;
    });

    this.myPlayer.addEventListener(amp.eventName.seeking, () => {
      const now = new Date();
      //console.log("Seeking " + now.toTimeString());
      this.seeking = true;
    });

    this.myPlayer.addEventListener(amp.eventName.seeked, () => {
      const now = new Date();
      //console.log("Seeked " + now.toTimeString());
      this.seeking = false;
    });

    this.myPlayer.addEventListener(amp.eventName.play, () => {
      const now = new Date();
      //console.log("==> Play " + now.toTimeString());
      if (this.myPlayer === undefined)
        return;

    });

    this.myPlayer.addEventListener(amp.eventName.loadeddata, () => {
      if (this.myPlayer === undefined)
        return;
    });

    this.myPlayer.addEventListener(amp.eventName.error, (evt: any) => {
      console.log("Video Player Error " + JSON.stringify(evt));
    });

    this.myPlayer.addEventListener(amp.eventName.playing, (evt: any) => {
      //console.log("Video Playing");
    });

    this.myPlayer.addEventListener(amp.eventName.complete, (evt: any) => {
      console.log("Video Play Complete");
      //this.props.completed();
    });
    this.myPlayer.addEventListener(amp.eventName.ended, (evt: any) => {
      console.log("Video Play Ended");
    });

    this.myPlayer.addEventListener(amp.eventName.durationchange, (evt: any) => {
      console.log("Video Duration " + this.myPlayer?.duration());
    });
  }

  async componentDidMount() {
    await this.initPlayer();
  }

  componentDidUpdate(prevProps: Readonly<AllProps>, prevState: Readonly<IState>) {
    
  }
  loadImage() {
    if (this.myPlayer === undefined)
      return;
  }

  pause() {
    if (this.myPlayer === undefined)
      return;
    }

  render() {
    return (
      <div hidden={this.props.hidden?? false}>
        <video
          ref={(input) => { this.videoRef = input; }}
          className="azuremediaplayer amp-default-skin"
          controls={true}
          width="100%"
          height="600"
          data-setup='{"nativeControlsForTouch": false}'
        />
      </div>
    );
  }
}